import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { TradeSpecificCompliance } from './trade-specific-compliance-form';

// Many of these fields CAN be nullable. May need to alter.

export class ComplianceSettingForm extends FormGroup<
  {
    id: FormControl<number | undefined>;
    riskLevel: FormControl<number | undefined>;
    CompanyId: FormControl<number | undefined>;

    companyIdentity: FormControl<number | null>;
    companyWatchlist: FormControl<number | null>;
    companyInGoodStanding: FormControl<boolean | null>;
    bankruptcy: FormControl<number | null>;
    companyLiens: FormControl<number | null>;
    isW9Checked: FormControl<boolean | null>;

    ownerIdentity: FormControl<0 | 10 | 20 | 30 | 40 | 50 | null>;
    ownerWatchlist: FormControl<0 | 1 | 2 | null>;
    ownerFelony: FormControl<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | null>;
    ownerMisdemeanor: FormControl<
      0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | null
    >;
    ownerBankruptcy: FormControl<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | null>;
    ownerLiens: FormControl<number | null>;
    ownerSexOffender: FormControl<boolean | null>;

    employeeMisdemeanor: FormControl<number | undefined>;
    employeeFelony: FormControl<number | undefined>;
    employeeSexOffender: FormControl<boolean>;

    generalLiability_isRequired: FormControl<boolean>;
    autoLiability_isRequired: FormControl<boolean>;
    umbrellaLiability_isRequired: FormControl<boolean>;
    workersCompensation_isRequired: FormControl<boolean>;
    errorsAndOmissions_isRequired: FormControl<boolean>;

    generalLiability_amBestRating: FormControl<string | undefined>;
    generalLiability_policyAmountPerOccurance: FormControl<number | undefined>;
    generalLiability_policyAmountAggregate: FormControl<number | undefined>;
    generalLiability_productOps: FormControl<number | undefined>;
    generalLiability_medicalExpenses: FormControl<number | undefined>;
    generalLiability_damageToRentedPremises: FormControl<number | undefined>;
    generalLiability_hasAiOngoingOps: FormControl<boolean>;
    generalLiability_hasAiCompOps: FormControl<boolean>;
    generalLiability_hasPnc: FormControl<boolean>;
    generalLiability_hasFullPolicyDoc: FormControl<boolean>;
    generalLiability_nonOwnedAutoAmount: FormControl<number | undefined>;
    generalLiability_hasRequiredForms: FormControl<boolean>;
    generalLiability_contractualLiability: FormControl<boolean>;
    generalLiability_isPerOccurrence: FormControl<boolean>;
    generalLiability_financialSizeCategory: FormControl<string | null>;
    personalAdvertisementInjury: FormControl<number | undefined>;
    generalLiability_hiredAutos: FormControl<number | undefined>;
    generalLiability_nonOwnedAutos: FormControl<number | undefined>;
    generalLiability_AllowNRRatedAMBestCarriers: FormControl<boolean>;
    generalLiability_InsNameFailed: FormControl<boolean>;
    generalLiability_legalNameMismatch: FormControl<boolean>;

    autoLiability_amBestRating: FormControl<string | undefined>;
    autoLiability_AllowNRRatedAMBestCarriers: FormControl<boolean>;
    autoLiability_combinedSingleLimit: FormControl<number | undefined>;
    autoLiability_propertyDamageLimit: FormControl<number | undefined>;
    autoLiability_bodilyInjuryPerPerson: FormControl<number | undefined>;
    autoLiability_bodilyInjuryPerAccident: FormControl<number | undefined>;
    autoLiability_hasNonOwnedAuto: FormControl<boolean>;
    autoLiability_hasFullPolicyDoc: FormControl<boolean>;
    autoLiability_hasRequiredForms: FormControl<boolean>;
    autoLiability_financialSizeCategory: FormControl<string | null>;
    allowNonCommercialPolicy: FormControl<boolean>;
    autoLiability_contingentAuto: FormControl<boolean>;
    autoLiability_trailerInterchange: FormControl<number | null>;
    autoLiability_cargoLiability: FormControl<number | null>;
    autoLiability_legalNameMismatch: FormControl<boolean>;

    excessLiability_amBestRating: FormControl<string | null>;
    excessLiability_policyAmountPerOccurance: FormControl<number | undefined>;
    excessLiability_policyAmountAggregate: FormControl<number | undefined>;

    umbrellaLiability_amBestRating: FormControl<string | null>;
    umbrellaLiability_policyAmountPerOccurance: FormControl<number | undefined>;
    umbrellaLiability_policyAmountAggregate: FormControl<number | undefined>;
    umbrellaLiability_hasFullPolicyDoc: FormControl<boolean>;
    umbrellaLiability_hasRequiredForms: FormControl<boolean>;
    umbrellaLiability_financialSizeCategory: FormControl<string | null>;
    umbrellaLiability_AllowNRRatedAMBestCarriers: FormControl<boolean>;
    umbrellaLiability_legalNameMismatch: FormControl<boolean>;

    workersCompensation_amBestRating: FormControl<string | null>;
    workersCompensation_eachIncidentEmployersLimit: FormControl<
      number | undefined
    >;
    workersCompensation_eachEmployeeMinimum: FormControl<number | undefined>;
    workersCompensation_eachEmployerMinimum: FormControl<number | undefined>;
    workersCompensation_hasRequiredForms: FormControl<boolean>;
    workersCompensation_officerExclusionNotAllowed: FormControl<boolean>;
    workersCompensation_financialSizeCategory: FormControl<string | null>;
    workersCompensation_AllowNRRatedAMBestCarriers: FormControl<boolean>;
    workersCompensation_legalNameMismatch: FormControl<boolean>;

    errorsAndOmissions_amBestRating: FormControl<string | null>;
    errorsAndOmissions_policyAmount: FormControl<number | undefined>;
    errorsAndOmissions_financialSizeCategory: FormControl<string | null>;
    professionalLiability_legalNameMismatch: FormControl<boolean>;

    pl_AllowNRRatedAMBestCarriers: FormControl<boolean>;

    tradeSpecificCoverage_amBestRating: FormControl<string | null>;
    tradeSpecificCoverage_autoOnHookCargoMinimumCoverage: FormControl<
      number | undefined
    >;
    tradeSpecificCoverage_autoGarageKeepersMinimumCoverage: FormControl<
      number | undefined
    >;
    tradeSpecificCoverage_GLPollutionCoverage: FormControl<number | undefined>;
    tradeSpecificCoverage_CrimeDishonestyFidelityBondCoverage: FormControl<
      number | undefined
    >;
    tradeSpecificCoverage_financialSizeCategory: FormControl<string | null>;

    glAdditionalInsuredEndorsements: FormControl<boolean>;
    umbrellaLiability_InsNameFailed: FormControl<boolean>;
    autoAdditionalInsuredEndorsements: FormControl<boolean>;
    autoLiability_InsNameFailed: FormControl<boolean>;
    workersCompensation_InsNameFailed: FormControl<boolean>;
    professionalLiability_InsNameFailed: FormControl<boolean>;

    siteType: FormControl<'on' | 'off' | 'global' | undefined>;

    glIsNamed: FormControl<boolean>;
    autoIsNamed: FormControl<boolean>;
    umbIsNamed: FormControl<boolean>;
    wkIsNamed: FormControl<boolean>;
    errIsNamed: FormControl<boolean>;
    tradeIsNamed: FormControl<boolean>;
    glDescOps: FormControl<boolean>;
    autoDescOps: FormControl<boolean>;
    umbDescOps: FormControl<boolean>;
    wkDescOps: FormControl<boolean>;
    errDescOps: FormControl<boolean>;
    tradeDescOps: FormControl<boolean>;
    glIsAgency: FormControl<boolean>;
    autoIsAgency: FormControl<boolean>;
    umbIsAgency: FormControl<boolean>;
    wkIsAgency: FormControl<boolean>;
    errIsAgency: FormControl<boolean>;
    tradeIsAgency: FormControl<boolean>;

    sampleCert: FormControl<string | null>;
    disallowWCExemptions: FormControl<boolean>;

    generalLiability_perProjLocAgg: FormControl<boolean>;
    umbrellaLiability_primaryNonContributory: FormControl<boolean>;
    umbrellaLiability_occurrenceBased: FormControl<boolean>;
    complianceSettingType: FormControl<string | undefined>;
    CompanyComplianceTypeId: FormControl<number | undefined>;
  } & {
    TradeSpecificCompliances?: FormArray<TradeSpecificCompliance>;
  }
> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      riskLevel: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),

      companyIdentity: new FormControl<number | null>(null),
      companyWatchlist: new FormControl<number | null>(null),
      companyInGoodStanding: new FormControl<boolean | null>(null),
      bankruptcy: new FormControl<number | null>(null),
      companyLiens: new FormControl<number | null>(null),
      isW9Checked: new FormControl<boolean | null>(false),

      ownerIdentity: new FormControl<0 | 10 | 20 | 30 | 40 | 50 | null>(null),
      ownerWatchlist: new FormControl<0 | 1 | 2 | null>(null),
      ownerFelony: new FormControl<
        0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | null
      >(null),
      ownerMisdemeanor: new FormControl<
        0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | null
      >(null),
      ownerBankruptcy: new FormControl<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | null>(
        null
      ),
      ownerLiens: new FormControl<number | null>(null),
      ownerSexOffender: new FormControl<boolean | null>(null),

      employeeMisdemeanor: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      employeeFelony: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      employeeSexOffender: new FormControl<boolean>(false, {
        nonNullable: true
      }),

      generalLiability_isRequired: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoLiability_isRequired: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      umbrellaLiability_isRequired: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      workersCompensation_isRequired: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      errorsAndOmissions_isRequired: new FormControl<boolean>(false, {
        nonNullable: true
      }),

      generalLiability_amBestRating: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      generalLiability_policyAmountPerOccurance: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      generalLiability_policyAmountAggregate: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      generalLiability_productOps: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      generalLiability_medicalExpenses: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      generalLiability_damageToRentedPremises: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      generalLiability_hasAiOngoingOps: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_hasAiCompOps: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_hasPnc: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_hasFullPolicyDoc: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_nonOwnedAutoAmount: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      generalLiability_hasRequiredForms: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_contractualLiability: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_isPerOccurrence: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_financialSizeCategory: new FormControl<string | null>(
        null
      ),
      personalAdvertisementInjury: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      generalLiability_hiredAutos: new FormControl<number | undefined>(
        undefined,
        { nonNullable: true }
      ),
      generalLiability_nonOwnedAutos: new FormControl<number | undefined>(
        undefined,
        { nonNullable: true }
      ),
      generalLiability_AllowNRRatedAMBestCarriers: new FormControl<boolean>(
        false,
        { nonNullable: true }
      ),
      generalLiability_InsNameFailed: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      generalLiability_legalNameMismatch: new FormControl<boolean>(true, {
        nonNullable: true
      }),

      autoLiability_amBestRating: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      autoLiability_AllowNRRatedAMBestCarriers: new FormControl<boolean>(
        false,
        { nonNullable: true }
      ),
      autoLiability_combinedSingleLimit: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      autoLiability_propertyDamageLimit: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      autoLiability_bodilyInjuryPerPerson: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      autoLiability_bodilyInjuryPerAccident: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      autoLiability_hasNonOwnedAuto: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoLiability_hasFullPolicyDoc: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoLiability_hasRequiredForms: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoLiability_financialSizeCategory: new FormControl<string | null>(null),
      allowNonCommercialPolicy: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoLiability_contingentAuto: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      autoLiability_trailerInterchange: new FormControl<number | null>(null),
      autoLiability_cargoLiability: new FormControl<number | null>(null),
      autoLiability_legalNameMismatch: new FormControl<boolean>(true, {
        nonNullable: true
      }),

      excessLiability_amBestRating: new FormControl<string | null>(null),
      excessLiability_policyAmountPerOccurance: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      excessLiability_policyAmountAggregate: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),

      umbrellaLiability_amBestRating: new FormControl<string | null>(null),
      umbrellaLiability_policyAmountPerOccurance: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      umbrellaLiability_policyAmountAggregate: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      umbrellaLiability_hasFullPolicyDoc: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      umbrellaLiability_hasRequiredForms: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      umbrellaLiability_financialSizeCategory: new FormControl<string | null>(
        null
      ),
      umbrellaLiability_AllowNRRatedAMBestCarriers: new FormControl<boolean>(
        false,
        { nonNullable: true }
      ),
      umbrellaLiability_legalNameMismatch: new FormControl<boolean>(true, {
        nonNullable: true
      }),

      workersCompensation_amBestRating: new FormControl<string | null>(null),
      workersCompensation_eachIncidentEmployersLimit: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      workersCompensation_eachEmployeeMinimum: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      workersCompensation_eachEmployerMinimum: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      workersCompensation_hasRequiredForms: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      workersCompensation_officerExclusionNotAllowed: new FormControl<boolean>(
        false,
        { nonNullable: true }
      ),
      workersCompensation_financialSizeCategory: new FormControl<string | null>(
        null
      ),
      workersCompensation_AllowNRRatedAMBestCarriers: new FormControl<boolean>(
        false,
        { nonNullable: true }
      ),
      workersCompensation_legalNameMismatch: new FormControl<boolean>(true, {
        nonNullable: true
      }),

      errorsAndOmissions_amBestRating: new FormControl<string | null>(null),
      errorsAndOmissions_policyAmount: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      errorsAndOmissions_financialSizeCategory: new FormControl<string | null>(
        null
      ),
      professionalLiability_legalNameMismatch: new FormControl<boolean>(true, {
        nonNullable: true
      }),

      pl_AllowNRRatedAMBestCarriers: new FormControl<boolean>(false, {
        nonNullable: true
      }),

      tradeSpecificCoverage_amBestRating: new FormControl<string | null>(null),
      tradeSpecificCoverage_autoOnHookCargoMinimumCoverage: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      tradeSpecificCoverage_autoGarageKeepersMinimumCoverage: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      tradeSpecificCoverage_GLPollutionCoverage: new FormControl<
        number | undefined
      >({ value: undefined, disabled: false }, { nonNullable: true }),
      tradeSpecificCoverage_CrimeDishonestyFidelityBondCoverage:
        new FormControl<number | undefined>(
          { value: undefined, disabled: false },
          { nonNullable: true }
        ),
      tradeSpecificCoverage_financialSizeCategory: new FormControl<
        string | null
      >(null),

      glAdditionalInsuredEndorsements: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      umbrellaLiability_InsNameFailed: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoAdditionalInsuredEndorsements: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      autoLiability_InsNameFailed: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      workersCompensation_InsNameFailed: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      professionalLiability_InsNameFailed: new FormControl<boolean>(false, {
        nonNullable: true
      }),

      siteType: new FormControl<'on' | 'off' | 'global' | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),

      glIsNamed: new FormControl<boolean>(false, { nonNullable: true }),
      autoIsNamed: new FormControl<boolean>(false, { nonNullable: true }),
      umbIsNamed: new FormControl<boolean>(false, { nonNullable: true }),
      wkIsNamed: new FormControl<boolean>(false, { nonNullable: true }),
      errIsNamed: new FormControl<boolean>(false, { nonNullable: true }),
      tradeIsNamed: new FormControl<boolean>(false, { nonNullable: true }),
      glDescOps: new FormControl<boolean>(false, { nonNullable: true }),
      autoDescOps: new FormControl<boolean>(false, { nonNullable: true }),
      umbDescOps: new FormControl<boolean>(false, { nonNullable: true }),
      wkDescOps: new FormControl<boolean>(false, { nonNullable: true }),
      errDescOps: new FormControl<boolean>(false, { nonNullable: true }),
      tradeDescOps: new FormControl<boolean>(false, { nonNullable: true }),
      glIsAgency: new FormControl<boolean>(false, { nonNullable: true }),
      autoIsAgency: new FormControl<boolean>(false, { nonNullable: true }),
      umbIsAgency: new FormControl<boolean>(false, { nonNullable: true }),
      wkIsAgency: new FormControl<boolean>(false, { nonNullable: true }),
      errIsAgency: new FormControl<boolean>(false, { nonNullable: true }),
      tradeIsAgency: new FormControl<boolean>(false, { nonNullable: true }),

      sampleCert: new FormControl<string | null>(null),
      disallowWCExemptions: new FormControl<boolean>(false, {
        nonNullable: true
      }),

      generalLiability_perProjLocAgg: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      umbrellaLiability_primaryNonContributory: new FormControl<boolean>(
        false,
        { nonNullable: true }
      ),
      umbrellaLiability_occurrenceBased: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      complianceSettingType: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyComplianceTypeId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      )
    });
  }
}
